import { formatPhone } from '../../../../utils/formatInputs';
import { RadioButton } from '../../../ui/radioButton';
import { useLocalization } from 'src/utils/useLocalization';
import React, { useEffect, useState } from 'react';
import './style.scss';

export interface IReferences {
    handleChangeItemReferences?: Function;
    initialReferences?: any;
}

export interface IReference {
    firstName: string;
    middleInitial: string;
    lastName: string;
    referencePhone: string;
    relationship: string;
    errorFirstName?: boolean;
    errorLastName?: boolean;
    errorPhone?: boolean;
}

const CERO = 0;
const ONE = 1;
const MINUSONE = -1;
const MAXREFERENCES = 3;

const References: React.FC<IReferences> = ({
    handleChangeItemReferences,
    initialReferences = null,
}) => {
    const { applicantInfo } = useLocalization();

    const [references, setReferences] = useState<IReference[]>([]);

    const optionsReferenceType = [
        { value: 'Friend', label: applicantInfo.REFERENCE_FRIEND },
        { value: 'Relative', label: applicantInfo.REFERENCE_RELATIVE },
        { value: 'Landlord', label: applicantInfo.REFERENCE_LANDLORD },
        { value: 'Other', label: applicantInfo.REFERENCE_OTHER },
    ];

    useEffect(() => {
        if (handleChangeItemReferences) {
            handleChangeItemReferences(references);
        }
    }, [references]);

    //for edit mode
    useEffect(() => {
        if (!initialReferences || initialReferences?.Name?.FirstName === '')
            return;

        let applicantReferences = [];

        if (Array.isArray(initialReferences)) {
            applicantReferences = initialReferences.map((reference) => {
                const newReference = {
                    firstName: reference?.Name?.FirstName ?? '',
                    middleInitial: reference?.Name?.MiddleInitial ?? '',
                    lastName: reference?.Name?.LastName ?? '',
                    referencePhone: reference?.PhoneNumber?.PhoneNumber ?? '',
                    relationship: reference?.RelationshipType ?? '',
                };
                return newReference;
            });
        } else {
            const newReference = {
                firstName: initialReferences?.Name?.FirstName ?? '',
                middleInitial: initialReferences?.Name?.MiddleInitial ?? '',
                lastName: initialReferences?.Name?.LastName ?? '',
                referencePhone:
                    initialReferences?.PhoneNumber?.PhoneNumber ?? '',
                relationship: initialReferences?.RelationshipType ?? '',
            };

            applicantReferences.push(newReference);
        }
        setReferences(applicantReferences);
    }, []);

    const validateNames = (stringToCheck: string) => {
        return validateNonNumericString(stringToCheck) || stringToCheck == '';
    };

    const validateNonNumericString = (stringToCheck: string) => {
        return /\d/.test(stringToCheck);
    };

    const handleKeyDownPhone = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const allowedKeys = [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Tab',
            'Home',
            'End',
        ];

        const allowedChars = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '(',
            ')',
            '-',
            ' ',
        ];

        if (!allowedKeys.includes(e.key) && !allowedChars.includes(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <>
            <div className='section-title'>{applicantInfo.REFERENCE_TITLE}</div>
            <button
                className='c-btn c-btn--secondary'
                type='button'
                onClick={() => {
                    if (references.length < MAXREFERENCES)
                        setReferences([
                            ...references,
                            {
                                firstName: '',
                                middleInitial: '',
                                lastName: '',
                                referencePhone: '',
                                relationship: 'Friend',
                            },
                        ]);
                }}
            >
                <span className='c-btn__text'>
                    {applicantInfo.REFERENCE_ADD}
                </span>
            </button>
            <div>
                {references.map((item, index) => (
                    <div className='reference-section' key={index}>
                        <div className='reference-division'></div>
                        <div className='o-fieldset__row'>
                            <div className='o-layout'>
                                <div className='o-layout__item  u-1/3  u-1/1@xs'>
                                    <div className='c-form-field'>
                                        <label
                                            htmlFor='m1l7e063'
                                            className='c-form-field__label'
                                        >
                                            {applicantInfo.FIRSTNAME_LABEL.slice(
                                                CERO,
                                                MINUSONE,
                                            )}
                                        </label>
                                        <div className='c-form-field__box'>
                                            <div className='c-input align-items'>
                                                <input
                                                    className={`c-input__input ${
                                                        item.errorFirstName
                                                            ? 'is-error'
                                                            : ''
                                                    }`}
                                                    type='text'
                                                    placeholder=''
                                                    value={item.firstName}
                                                    onChange={(event) => {
                                                        const value =
                                                            event.target.value;

                                                        const isValid =
                                                            /^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]*$/.test(
                                                                value,
                                                            );

                                                        if (!isValid) return;

                                                        setReferences(
                                                            (oldValues) => {
                                                                const aux = [
                                                                    ...oldValues,
                                                                ];
                                                                aux[index] = {
                                                                    ...aux[
                                                                        index
                                                                    ],
                                                                    firstName:
                                                                        value,
                                                                    errorFirstName:
                                                                        validateNames(
                                                                            value,
                                                                        ),
                                                                };
                                                                return aux;
                                                            },
                                                        );
                                                    }}
                                                    minLength={1}
                                                    maxLength={20}
                                                />
                                            </div>
                                            <div>
                                                {item.errorFirstName ? (
                                                    <span
                                                        className={
                                                            'c-error-message'
                                                        }
                                                        style={{
                                                            position:
                                                                'absolute',
                                                        }}
                                                    >
                                                        {
                                                            applicantInfo.FIRSTNAME_ERROR
                                                        }
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='o-layout__item  u-1/3  u-1/1@xs'>
                                    <div className='c-form-field'>
                                        <label
                                            htmlFor='m1l7e063'
                                            className='c-form-field__label'
                                        >
                                            {applicantInfo.MI_LABEL}
                                        </label>
                                        <div className='c-form-field__box'>
                                            <div className='c-input align-items'>
                                                <input
                                                    className={'c-input__input'}
                                                    type='text'
                                                    placeholder=''
                                                    value={item.middleInitial}
                                                    onChange={(event) => {
                                                        setReferences(
                                                            (oldValues) => {
                                                                const aux = [
                                                                    ...oldValues,
                                                                ];
                                                                if (
                                                                    !validateNonNumericString(
                                                                        event
                                                                            .target
                                                                            .value,
                                                                    )
                                                                ) {
                                                                    aux[
                                                                        index
                                                                    ].middleInitial =
                                                                        event.target.value;
                                                                }
                                                                return aux;
                                                            },
                                                        );
                                                    }}
                                                    minLength={0}
                                                    maxLength={1}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='o-layout__item  u-1/3  u-1/1@xs'>
                                    <div className='c-form-field'>
                                        <label
                                            htmlFor='m1l7e063'
                                            className='c-form-field__label'
                                        >
                                            {applicantInfo.LASTNAME_LABEL.slice(
                                                CERO,
                                                MINUSONE,
                                            )}
                                        </label>
                                        <div className='c-form-field__box'>
                                            <div className='c-input align-items'>
                                                <input
                                                    className={`c-input__input ${
                                                        item.errorLastName
                                                            ? 'is-error'
                                                            : ''
                                                    }`}
                                                    type='text'
                                                    placeholder=''
                                                    value={item.lastName}
                                                    onChange={(event) => {
                                                        const value =
                                                            event.target.value;

                                                        const isValid =
                                                            /^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]*$/.test(
                                                                value,
                                                            );

                                                        if (!isValid) return;

                                                        setReferences(
                                                            (oldValues) => {
                                                                const aux = [
                                                                    ...oldValues,
                                                                ];
                                                                aux[index] = {
                                                                    ...aux[
                                                                        index
                                                                    ],
                                                                    lastName:
                                                                        value,
                                                                    errorLastName:
                                                                        validateNames(
                                                                            value,
                                                                        ),
                                                                };
                                                                return aux;
                                                            },
                                                        );
                                                    }}
                                                    minLength={1}
                                                    maxLength={20}
                                                />
                                            </div>
                                            <div>
                                                {item.errorLastName ? (
                                                    <span
                                                        className={
                                                            'c-error-message'
                                                        }
                                                        style={{
                                                            position:
                                                                'absolute',
                                                        }}
                                                    >
                                                        {
                                                            applicantInfo.LASTNAME_ERROR
                                                        }
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='o-fieldset__row'>
                            <div className='o-layout'>
                                <div className='o-layout__item  u-1/3  u-1/1@xs'>
                                    <div className='c-form-field'>
                                        <label
                                            htmlFor='m1l7e063'
                                            className='c-form-field__label'
                                        >
                                            {applicantInfo.REFERENCE_PHONE}
                                        </label>
                                        <div className='c-form-field__box'>
                                            <div className='c-input align-items'>
                                                <input
                                                    className={`c-input__input ${
                                                        item.errorPhone
                                                            ? 'is-error'
                                                            : ''
                                                    }`}
                                                    type='text'
                                                    placeholder=''
                                                    value={item.referencePhone}
                                                    onChange={(event) => {
                                                        setReferences(
                                                            (oldValues) => {
                                                                const aux = [
                                                                    ...oldValues,
                                                                ];
                                                                if (
                                                                    event.target
                                                                        .value
                                                                        .length >
                                                                    aux[index]
                                                                        .referencePhone
                                                                        .length
                                                                ) {
                                                                    aux[
                                                                        index
                                                                    ].referencePhone =
                                                                        formatPhone(
                                                                            event
                                                                                .target
                                                                                .value,
                                                                        );
                                                                } else {
                                                                    aux[
                                                                        index
                                                                    ].referencePhone =
                                                                        event.target.value;
                                                                }
                                                                aux[
                                                                    index
                                                                ].errorPhone =
                                                                    event.target
                                                                        .value ==
                                                                    '';
                                                                return aux;
                                                            },
                                                        );
                                                    }}
                                                    minLength={1}
                                                    maxLength={14}
                                                    onKeyDown={
                                                        handleKeyDownPhone
                                                    }
                                                />
                                            </div>
                                            <div>
                                                {item.errorPhone ? (
                                                    <span
                                                        className={
                                                            'c-error-message'
                                                        }
                                                        style={{
                                                            position:
                                                                'absolute',
                                                        }}
                                                    >
                                                        {
                                                            applicantInfo.PHONE_ERROR
                                                        }
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='o-layout__item  u-1/3  u-1/1@xs'>
                                    <div className='c-form-field'>
                                        <label
                                            htmlFor='m1lh7pdb'
                                            className='c-form-field__label'
                                        >
                                            {applicantInfo.REFERENCE_LABEL}
                                        </label>
                                        <div className='c-form-field__box radio-box'>
                                            <RadioButton
                                                name={`typeOfReference${index}-${Math.random()}`}
                                                options={optionsReferenceType.map(
                                                    (reference) =>
                                                        reference.value,
                                                )}
                                                onSelect={(value) => {
                                                    setReferences(
                                                        (oldValues) => {
                                                            const aux = [
                                                                ...oldValues,
                                                            ];
                                                            aux[
                                                                index
                                                            ].relationship =
                                                                value;
                                                            return aux;
                                                        },
                                                    );
                                                }}
                                                selectedOption={
                                                    item.relationship
                                                }
                                                labels={optionsReferenceType.map(
                                                    (reference) =>
                                                        reference.label,
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            className='c-btn c-btn--secondary'
                            type='button'
                            onClick={() => {
                                setReferences((oldValue) => {
                                    const aux = [...oldValue];
                                    aux.splice(index, ONE);
                                    return aux;
                                });
                            }}
                        >
                            <span className='c-btn__text'>
                                {applicantInfo.REFERENCE_REMOVE}
                            </span>
                        </button>
                    </div>
                ))}
                {references.length > CERO && (
                    <div className='reference-division end'></div>
                )}
            </div>
        </>
    );
};

export default References;
